import { Component } from '@angular/core';

@Component({
    // tslint:disable-next-line
    selector: 'body',
    template: '<router-outlet></router-outlet>'
})
export class AppComponent { }


// WEBPACK FOOTER //
// /var/www/backend/src/app/app.component.ts